import { ReactNode, useEffect, useCallback, useMemo } from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import { LoginPage } from '../LoginPage';
import { trpcTenant } from './trpcTenant';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext, AuthContextType } from './useAuthTenant';
import { buildLoginRedirectUrl } from '@duke-hq/libauth-client/safeRedirectParam';
import { SelfSignup } from '../SelfSignup';

export function AuthProviderTenant({ children }: { children: ReactNode }) {
  const logout = trpcTenant.auth.logout.useMutation();
  const { data: user, isLoading } = trpcTenant.me.useQuery(undefined, {
    retry: false,
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      user === null &&
      isLoading === false &&
      location.pathname !== '/login' &&
      location.pathname !== '/signup' &&
      location.pathname !== '/magiclink' &&
      location.pathname !== '/oidc/azure/callback'
    ) {
      navigate(buildLoginRedirectUrl('/login', location.pathname, location.search), {
        replace: true,
      });
      return;
    }
  }, [user, isLoading, location.pathname, location.search, navigate]);

  const signOut = useCallback(async () => {
    await logout.mutateAsync();
    window.location.replace('/login');
  }, [logout]);

  // @ts-expect-error - existing error
  const value: AuthContextType = useMemo(
    () => ({
      user,
      signOut,
    }),
    [user, signOut],
  );

  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!user) {
    return location.pathname === '/signup' ? <SelfSignup /> : <LoginPage />;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
